/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Contains global configuration for API services
 */
@Injectable()
export class ApiConfiguration {
  // rootUrl: string = "http://192.168.30.65:10010/api/v1";
  // rootUrl: string = "http://localhost:10010/api/v1";

  //rootUrl: string = "http://cryosoft-dev-api.dfm-engineering.com/api/v1";
  rootUrl: string = "https://cryosoft-api.dfm-europe.com/api/v1";

}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/api-configuration.ts